import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HelpAssistant from './HelpAssistant';

function AssistantPanel() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== '/hjalp' || !location.hash) return undefined;
    const frame = requestAnimationFrame(() => {
      document.getElementById(location.hash.slice(1))?.scrollIntoView?.({ block: 'start' });
    });
    return () => cancelAnimationFrame(frame);
  }, [location]);
  const [open, setOpen] = useState(false);
  const launcher = useRef(null);
  const closeButton = useRef(null);
  useEffect(() => {
    if (open) closeButton.current?.focus();
  }, [open]);
  function close() {
    setOpen(false);
    launcher.current?.focus();
  }
  function openSource(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.currentTarget.getAttribute('href');
    event.preventDefault();
    close();
    navigate(target);
  }
  return <div className="ai-assistant-floating">
    {open && <section id="ai-assistant-panel" role="dialog" aria-labelledby="ai-assistant-title"
      className="ai-assistant-panel bg-white text-slate-800 shadow-2xl"
      onKeyDown={event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
      }}>
      <header className="flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 px-4 py-3">
        <h2 id="ai-assistant-title" className="text-lg font-bold">AI-assistent</h2>
        <button ref={closeButton} onClick={close} aria-label="Stäng AI-assistenten"
          className="theme-button-secondary min-h-[44px] min-w-[44px] px-3 py-2">Stäng</button>
      </header>
      <div className="min-h-0 overflow-y-auto overscroll-contain p-4">
        <HelpAssistant onSourceNavigate={openSource} />
      </div>
    </section>}
    <button ref={launcher} type="button" className="theme-button-primary ml-auto flex min-h-[48px] items-center gap-2 px-5 py-3 shadow-lg"
      aria-expanded={open} aria-controls={open ? 'ai-assistant-panel' : undefined} aria-haspopup="dialog"
      aria-label={open ? 'Stäng AI-assistenten' : 'Öppna AI-assistenten'} onClick={() => open ? close() : setOpen(true)}>
      <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 4V6a2 2 0 0 1 2-2Z" />
        <path d="M8 9h8M8 13h5" />
      </svg>
      {open ? 'Stäng' : 'Fråga AI'}
    </button>
  </div>;
}

export default function FloatingHelpAssistant({ userRole, sessionKey }) {
  if (![1, 2, 3, 4, 5].includes(userRole)) return null;
  // En ny roll eller ett nytt konto får aldrig behålla tidigare svar.
  return <AssistantPanel key={`${userRole}:${sessionKey}`} />;
}
